import { TOGGLE_YLOPO_OPT_IN_MODAL } from 'src/actions/actionTypes'

const initialState = {
  showModal: false,
  ylopoUrl: undefined
}

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case TOGGLE_YLOPO_OPT_IN_MODAL:
      return {
        ...state,
        showModal: !state.showModal,
        ylopoUrl: payload.ylopoUrl
      }
    default:
      return state
  }
}
